var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4TZ0V8zeGnY1PLR6bjG5h"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["emak-frontend@webranking-srl"]={id:"4TZ0V8zeGnY1PLR6bjG5h"};
      